import React from 'react';
import { Section } from './ui/Section';
import { ShoppingBag, FileText, AlertTriangle, Leaf } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: <AlertTriangle className="w-6 h-6 text-[#EF4444]" data-id="element-56" />,
    title: 'Banderas Rojas',
    desc: 'Claras por sistema (respiratorio, digestivo, piel, fiebre) para saber cuándo parar.'
  }, {
    icon: <ShoppingBag className="w-6 h-6 text-[#C9963A]" data-id="element-57" />,
    title: 'Lista de Compras',
    desc: 'Botiquín mínimo y completo. Ingredientes que conseguís en el súper.'
  }, {
    icon: <Leaf className="w-6 h-6 text-[#1B4332]" data-id="element-58" />,
    title: 'Preparaciones Base',
    desc: 'Las 7 técnicas maestras que resuelven el 80% de los problemas cotidianos.'
  }, {
    icon: <FileText className="w-6 h-6 text-[#2D6A4F]" data-id="element-59" />,
    title: 'Fichas Imprimibles',
    desc: "'Me pasa esto → hago esto'. Diseñadas para pegar en la heladera."
  }];
  const protocols = ['Garganta, congestión, tos', 'Gases, hinchazón, acidez ocasional', 'Diarrea / Estreñimiento leve', 'Picaduras, irritación, quemaduras pequeñas', 'Estrés nocturno y sueño (apoyo suave)'];
  return <Section background="white" data-id="element-60">
      <div className="text-center mb-10" data-id="element-61">
        <h2 className="text-3xl md:text-4xl mb-3" data-id="element-62">
          Qué vas a encontrar adentro
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-63">
          Todo el contenido está diseñado para ser consumido rápido. Sin
          relleno.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-10" data-id="element-64">
        {features.map((f, i) => <div key={i} className="bg-[#FDF8F0] p-5 rounded-xl border border-[#1B4332]/5 hover:shadow-md transition-shadow" data-id="element-65">
            <div className="mb-3 bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm" data-id="element-66">
              {f.icon}
            </div>
            <h3 className="text-lg font-bold mb-2 text-[#1B4332]" data-id="element-67">{f.title}</h3>
            <p className="text-sm text-gray-600" data-id="element-68">{f.desc}</p>
          </div>)}
      </div>

      <div className="bg-[#1B4332]/5 rounded-2xl p-6 md:p-8" data-id="element-69">
        <h3 className="text-2xl font-bold text-center mb-5 text-[#1B4332]" data-id="element-70">
          Protocolos Simples Incluidos
        </h3>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-71">
          {protocols.map((p, i) => <div key={i} className="bg-white px-4 py-3 rounded-lg shadow-sm flex items-center gap-3 border border-[#1B4332]/10" data-id="element-72">
              <div className="w-2 h-2 bg-[#C9963A] rounded-full" data-id="element-73" />
              <span className="font-medium text-gray-800" data-id="element-74">{p}</span>
            </div>)}
          <div className="bg-[#1B4332] text-white px-4 py-3 rounded-lg shadow-sm flex items-center justify-center font-bold cursor-pointer hover:bg-[#2D6A4F] transition-colors" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-75">
            + Y mucho más
          </div>
        </div>
      </div>
    </Section>;
}